import {orderStatus} from 'shared/models/api';

export const ORDER_STATUS = 'ORDER_STATUS';

const init = {};

export default function(state = init, action = {}) {
  switch (action.type) {
    case ORDER_STATUS:
      return {...state, order: action.order};
    default:
      return state;
  }
}

export function getStatus(id) {
  return dispatch => {
    orderStatus(id).then(result => dispatch({type: ORDER_STATUS, order: result}));
  }
}



// WEBPACK FOOTER //
// ./shared/components/orderTracking/actions.js